import {
    ButtonGradientPrimary,
    Card,
    Colors,
    FIXED_ICON_SIZES,
    Heading,
    Icon,
    Text,
} from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';
import { cycleCreateButtonHeight } from '@/utils/cycleStyles';

interface CycleEvaluationEmptyListProps {
    searchText: string;
    hasActiveFilters: boolean;
    onCreateCycle: () => void;
}

export const CycleEvaluationEmptyList = ({
    searchText,
    hasActiveFilters,
    onCreateCycle,
}: CycleEvaluationEmptyListProps) => {
    const { t } = useAmelioTranslations();

    if (searchText !== '' || hasActiveFilters) {
        return <Text>{t('cycleEvaluationDashboard.noResultsFound')}</Text>;
    }

    return (
        <Card
            className={
                'flex max-w-3xl !flex-col !items-stretch !justify-start !gap-4 md:!flex-row md:!items-center md:!justify-between md:!gap-0'
            }
        >
            <Heading
                level={3}
                weight={'medium'}
                className={'min-w-0 wrap-break-word'}
            >
                {t('cycleEvaluationDashboard.emptyList')}
            </Heading>

            <ButtonGradientPrimary
                size={'md'}
                onClick={onCreateCycle}
                className={`!mt-4 flex !w-full flex-shrink-0 md:!mt-0 md:!ml-[21px] md:!w-auto ${cycleCreateButtonHeight}`}
                dataTestId={'create-cycle-button'}
                leftIcon={
                    <Icon
                        name={'essential-add-circle'}
                        color={Colors.WHITE}
                        className={'mr-2'}
                        size={FIXED_ICON_SIZES.md}
                    />
                }
            >
                {t('cycleEvaluationDashboard.evaluationCycles.createTemplate')}
            </ButtonGradientPrimary>
        </Card>
    );
};
